import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** アクション許可 */
enum Effect {
  allow = '1',
  deny = '2',
}

const nameConfig = {
  allow: new Map([
    [Locale.ja, '許可'],
    [Locale.en, 'Allow'],
  ]),
  deny: new Map([
    [Locale.ja, '拒否'],
    [Locale.en, 'Deny'],
  ]),
};

const toEnum = rawValueToEnum(Effect, Effect.allow);
const toDisplay = enumToName(Effect, nameConfig);

export const effect = {
  enum: Effect,
  nameConfig,
  toDisplay,
  toEnum,
};

export type { Effect };
